/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable no-param-reassign */
import {
    useCallback, useMemo, useContext} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField, InputNumberField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import { Icon } from '@jutro/components';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './OperatorsInfo.metadata.json5';

function OperatorsInfo(props) {

    const {
        data: operatorInfoVM,
        updateWizardData,
        submissionVM,
        operatorInfoPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);

    const addOpeInfo = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            operatorInfoVM.value = operatorInfoVM.value || []

            const { _xCenter, _dtoName } = operatorInfoVM;

            const OpeInfoObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            OpeInfoObjVM.isValidationReq = true;
            OpeInfoObjVM.fie2 = operatorInfoVM?.value?.length + 1;

            operatorInfoVM.pushElement(
                OpeInfoObjVM
            );
            updateWizardData(submissionVM);
        },
        [operatorInfoVM, viewModelService, updateWizardData, submissionVM]
    );

    const handleValueChange = useCallback(
        () => {

            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            operatorInfoVM.value.splice(index, 1);

            operatorInfoVM.value.map((operator) => {
                if (operator.fie2 > index) {
                    operator.fie2 = operator.fie2 - 1;
                }
            })

            _.set(submissionVM.value, operatorInfoPath, operatorInfoVM.value);
            updateWizardData(submissionVM);
        }, [operatorInfoVM.value, submissionVM, operatorInfoPath, updateWizardData]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'fie2') {
                const value = !_.isUndefined(item.fie2) ? item.fie2 : index + 1;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'namPerProLasTreFie') {
                const value = item.namPerProLasTreFie ? item.namPerProLasTreFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namPerProLasTreFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaofEduFie') {
                const value = item.yeaofEduFie ? item.yeaofEduFie : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaofEduFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'yeaExpFie') {
                const value = item.yeaExpFie ? item.yeaExpFie : 0;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.yeaExpFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

        }, [handleValueChange])

    const removeOperatorInfoTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`OperatorsInfoTable`]: {
            data: operatorInfoVM?.value?.sort((a,b) => a.fie2 - b.fie2)
        }

    }), [operatorInfoVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addOpeInfo,
            getTableCell,
            removeOperatorInfoTableRow
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.componentContent,
            operatorInfoVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [operatorInfoVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={operatorInfoVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OperatorsInfo.propTypes = wizardProps;
export default withRouter(OperatorsInfo);
